import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { supabase } from '@/integrations/supabase/client'

interface ExamRulesPopupProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const ExamRulesPopup: React.FC<ExamRulesPopupProps> = ({ open, onOpenChange }) => {
  const { data } = supabase.storage.from('rules').getPublicUrl('rules.v2.pdf')
  const pdfUrl = data.publicUrl

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-full max-h-[80vh]">
        <div className="mt-4 h-[60vh] overflow-auto">
          <iframe src={pdfUrl} className="w-full h-full" />
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ExamRulesPopup
